// extracted by mini-css-extract-plugin
export var menuIcon = "_rj-0";
export var menuIconInline = "_rj-1";